module.exports = __webpack_public_path__ + "img/affinity_on.4bff7f13.svg";